import { FormikValues, useFormikContext } from "formik";
import lodashGet from "lodash/get";
import useOutsideClick from "shared/components/useOutsideClick";
import { ComponentPropsWithoutRef, useCallback, useRef, useState } from "react";
import { HslColor, HslColorPicker } from "react-colorful";
import PillarFormInputWrapper from "shared/components/pillar-form/components/PillarFormInputWrapper";

export type PillarFormColorInputProps = {
  name: string;
  label: string;
  labelClassName?: string;
  additionalClasses?: string;
  onChange?: (hsl: HslColor) => void;
} & Omit<ComponentPropsWithoutRef<"div">, "id" | "name" | "value" | "type">;

const PillarFormColorInput = ({
  name,
  label,
  labelClassName,
  additionalClasses,
  onChange,
  className,
  ...props
}: PillarFormColorInputProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const hsl = lodashGet(values, name, { h: 0, s: 0, l: 0 });

  const popover = useRef(null);
  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useOutsideClick(popover, close);

  return (
    <PillarFormInputWrapper
      name={name}
      labelClassName={labelClassName}
      label={label}
      additionalClasses={additionalClasses}
    >
      <div className={`relative ${className ?? ""}`} {...props}>
        <div
          className="colorpicker-swatch w-15 h-3 "
          style={{
            backgroundColor: `hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%)`,
          }}
          onClick={() => toggle(true)}
        />

        {isOpen && (
          <div
            className="colorpicker-popover left-0 absolute z-10"
            ref={popover}
          >
            <HslColorPicker
              color={hsl}
              onChange={(value) => {
                setFieldValue(name, value);
                onChange?.(value);
              }}
            />
          </div>
        )}
      </div>
    </PillarFormInputWrapper>
  );
};

export default PillarFormColorInput;
